import React from 'react';
import DefaultPaymentHeader from './default_header';
import Company3Module8Header from './3_8_header';

// Key 格式固定为 ModuleId_CompanyId，与特殊头部文件名保持一致。
const specialHeaderMap = {
  '3_8': Company3Module8Header,
};

const PaymentHeader = ({ job }) => {
  if (!job) {
    return null;
  }

  const headerKey = `${job.CompanyId}_${job.ModuleId}`;
  const HeaderComponent = specialHeaderMap[headerKey] || DefaultPaymentHeader;

  return <HeaderComponent job={job} company={job.Company} />;
};

export default PaymentHeader;
